import { UserMinus } from 'lucide-react';

// Quién es el titular de un pedido o de un bono, incluyendo el caso en el que
// ya no existe.
//
// Desde la mig 207 el borrado de una cuenta es real: la fila de `profiles`
// desaparece. El rastro económico se conserva por obligación contable, así que
// `orders.user_id` y `user_credits.user_id` quedan a NULL y el nombre pasa a
// vivir en `billing_name`, sellado en el momento del borrado.
//
// Sin este componente esas filas saldrían con el nombre vacío —el embed de
// `profiles` viene null— y parecerían un pedido sin dueño. Con él salen con su
// nombre y con la marca de que esa persona ya no está en el sistema.
//
// ⚠️ Y NO SE ENLAZA. Un enlace a la ficha de alguien borrado lleva a un 404, y
//    es un caso que se alcanza pulsando, no un caso teórico. Si algún día estas
//    listas enlazan al alumno, el enlace tiene que colgar de `userId`, nunca de
//    `nombre`: lo fija `titular-cuenta.test.tsx`.

interface Props {
  userId: string | null;
  fullName?: string | null;
  billingName?: string | null;
  className?: string;
}

export default function TitularCuenta({ userId, fullName, billingName, className }: Props) {
  if (userId) {
    return <span className={className}>{fullName ?? '—'}</span>;
  }

  // Cuenta borrada. `billingName` es lo que se selló; si tampoco está, la fila
  // es anterior a la 207 y no hay nombre que enseñar — se dice, no se finge.
  return (
    <span className={className} data-testid="titular-eliminado">
      <span className="text-text-secondary italic">{billingName ?? 'Titular desconocido'}</span>
      <span
        className="ml-2 inline-flex items-center gap-1 rounded border border-text-secondary/40 px-1.5 py-0.5 align-middle text-[10px] uppercase tracking-wide text-text-secondary"
        title="Esta persona ya no existe en el sistema. El registro se conserva por contabilidad."
      >
        <UserMinus size={10} />
        cuenta eliminada
      </span>
    </span>
  );
}
